export default __webpack_public_path__ + "public/assets/images/4c9dda9e487729172ac0bb03e1b0d776.png";